
import React, { useState, useCallback, useRef } from "react";
import * as Material from "@mui/material";
import { SearchRounded } from "@mui/icons-material";
import { Input, Button } from "@fragments";

export default function SearchBar({
    searchMode,
    setSearchMode,
    searchQueryRef,
    onSearch
}) {
    const searchInputRef = useRef(null);
    const [localValue, setLocalValue] = useState(searchQueryRef.current);

    const handleSearch = useCallback(() => {
        searchQueryRef.current = localValue; // Atualizar o valor global imediatamente
        onSearch();
    }, [localValue, onSearch, searchQueryRef]);

    const handleKeyPress = useCallback((event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }, [handleSearch]);

    const handleBlur = useCallback(() => {
        if (localValue !== searchQueryRef.current) {
            handleSearch();
        }
    }, [handleSearch, localValue, searchQueryRef]);

    const handleChange = useCallback((e) => {
        setLocalValue(e); // Apenas atualizar o valor local
    }, []);

    return (
        <div className="searchbar mt-3">
            <div className="search-container">
                <Input.Text
                    ref={searchInputRef}
                    placeholder={`Pesquisar cobrança pelo ${searchMode === 'email' ? 'email' : 'nome'} do cliente`}
                    value={localValue}
                    onInput={handleChange}
                    onKeyPress={handleKeyPress}
                    onBlur={handleBlur}
                    fullWidth
                    variant="large"
                    className="search-input"
                    start={
                        <div className="search-mode-toggle">
                            <Material.ToggleButtonGroup
                                value={searchMode}
                                exclusive
                                onChange={(e, newMode) => {
                                    if (newMode !== null) {
                                        setSearchMode(newMode);
                                    }
                                }}
                                size="small"
                                className="search-mode-toggle-group"
                            >
                                <Material.ToggleButton value="email">Email</Material.ToggleButton>
                                <Material.ToggleButton value="name">Nome</Material.ToggleButton>
                            </Material.ToggleButtonGroup>
                        </div>
                    }
                    end={
                        <Button
                            color="text"
                            onClick={handleSearch}
                            icon={<SearchRounded />}
                        />
                    }
                />
            </div>
        </div>
    )
}
